import i18n from "~/i18n";

// path: s3 폴더명
const S3_PATH = {
	// 사업자등록증
	COMPANY_BUSINESS: "company/business",
	// 법인인감
	COMPANY_SIGN: "company/sign",
	// 기업로고
	COMPANY_LOGO: "company/logo",
	// 제품이미지
	COMPANY_PRODUCT: "company/product",
	// 주요인력 사진
	COMPANY_MEMBER: "company/member",
	// 플러그인 정보
	PLUGIN_INFO: "plugin/info",
	// 개인서명
	USER_SIGN: "user/sign",
	// 사용자 사진
	USER_PROFILE: "user/profile",
	// IR 주요인력 사진
	IR_MEMBER: "ir/member",
	// 공통
	COMMON: "common",
	//apply startup 등록폼
	APPLY_STARTUP: "apply/startup",
};

//type: 파일 종류
const FILE_TYPE = {
	COMPANY_BUSINESS: i18n.t("common.constants.upload.companyBusiness"),
	COMPANY_SIGN: i18n.t("common.constants.upload.companySign"),
	COMPANY_LOGO: i18n.t("common.constants.upload.companyLogo"),
	COMPANY_PRODUCT: i18n.t("common.constants.upload.companyProduct"),
	COMPANY_MEMBER: i18n.t("common.constants.upload.companyMember"),
	PLUGIN_INFO: i18n.t("common.constants.upload.pluginInfo"),
	USER_SIGN: i18n.t("common.constants.upload.sign"),
	USER_PROFILE: i18n.t("common.constants.upload.userProfile"),
	IR_MEMBER: i18n.t("common.constants.upload.irMember"),
	COMMON: i18n.t("common.constants.upload.common"),
	APPLY_STARTUP: i18n.t("common.constants.upload.applyStartup"),
};

export const UPLOAD_TYPE = {
	COMPANY_BUSINESS: { type: FILE_TYPE.COMPANY_BUSINESS, path: S3_PATH.COMPANY_BUSINESS },
	COMPANY_SIGN: { type: FILE_TYPE.COMPANY_SIGN, path: S3_PATH.COMPANY_SIGN },
	COMPANY_LOGO: { type: FILE_TYPE.COMPANY_LOGO, path: S3_PATH.COMPANY_LOGO },
	COMPANY_PRODUCT: { type: FILE_TYPE.COMPANY_PRODUCT, path: S3_PATH.COMPANY_PRODUCT },
	COMPANY_MEMBER: { type: FILE_TYPE.COMPANY_MEMBER, path: S3_PATH.COMPANY_MEMBER },
	PLUGIN_INFO: { type: FILE_TYPE.PLUGIN_INFO, path: S3_PATH.PLUGIN_INFO },
	USER_SIGN: { type: FILE_TYPE.USER_SIGN, path: S3_PATH.USER_SIGN },
	USER_PROFILE: { type: FILE_TYPE.USER_PROFILE, path: S3_PATH.USER_PROFILE },
	IR_MEMBER: { type: FILE_TYPE.IR_MEMBER, path: S3_PATH.IR_MEMBER },
	COMMON: { type: FILE_TYPE.COMMON, path: S3_PATH.COMMON },
	APPLY_STARTUP: { type: FILE_TYPE.APPLY_STARTUP, path: S3_PATH.APPLY_STARTUP },
};
